import ImageSlider from "../components/ImageSlider";
import OurPartners from "../components/OurPartners";
import OurServices from "../components/Services";
import Message from "../components/Message";
export default function Home() {
  return (
    <>
      <ImageSlider />
      <Message />
      <OurServices />
      <OurPartners />
    </>
  );
}
